module.exports = __webpack_public_path__ + "img/shape-4-gold@2x.81051aa0.png";